module.exports = __webpack_public_path__ + "static/media/Product-Header-BG.5b2d3bfa.png";